import { r as registerInstance, h, H as Host } from './index-8f7fb048.js';

const marketFooterCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host{display:flex;flex-wrap:wrap;justify-content:space-between;width:100%;padding:var(--footer-vertical-padding-size) 0}:host ::slotted(.market-button-group){width:100%}";

const MarketFooter = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    return (h(Host, { class: "market-footer" }, h("slot", null)));
  }
};
MarketFooter.style = marketFooterCss;

export { MarketFooter as market_footer };
